export enum DelegationPurpose {
  MARKETING = 1,
  TRAINING = 2,
  COMPLAINTS = 3,
  MANAGEMENT = 4,
  GROUP_SERVICE = 5,
  OTHER = 6,
}
